import { useMemo } from "react";

import { isSelfHostedDistribution } from "utils/distribution";
import { MainNavigationItem } from "components/MainNavigation/types";

import {
  MainNavigationSecondaryMenuItemKeys,
  MAIN_NAVIGATION_SECONDARY_MENU_ITEMS,
} from "./menuItemsSecondary";

const isSelfHosted = isSelfHostedDistribution();

const useFeedbackItemSelfHosted = (): MainNavigationItem | undefined => {
  const item = useMemo(
    () =>
      MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[MainNavigationSecondaryMenuItemKeys.FeedbackSelfHosted],
    []
  );

  if (!isSelfHosted) {
    return undefined;
  }

  return item;
};

export default useFeedbackItemSelfHosted;
